"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Loader } from "lucide-react";
function ReservationFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 glass-effect">
                <p className="text-white text-lg font-semibold mb-4">{successMessage}</p>
                <Button onClick={resetForm} variant="outline" className="bg-white/10 text-white border-white/20 hover:bg-white/20">
                    Make Another Reservation
                </Button>
            </div>;
  }
  return <Form onSubmit={handleSubmit}>
            <div className="grid gap-6">
                <FormField control={control} name="full_name" render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-white">Full Name</FormLabel>
                            <FormControl>
                                <Input placeholder="John Doe" {...field} className="glass-effect text-white placeholder:text-white/60 border-white/20 focus-visible:border-secondary focus-visible:ring-secondary/30" />
                            </FormControl>
                            <FormDescription className="text-white/70 text-xs">First and last name</FormDescription>
                            <FormMessage />
                        </FormItem>} />

                <div className="grid md:grid-cols-2 gap-6">
                    <FormField control={control} name="email" render={({
          field
        }) => <FormItem>
                                <FormLabel className="text-white">Email Address</FormLabel>
                                <FormControl>
                                    <Input type="email" placeholder="john@example.com" {...field} className="glass-effect text-white placeholder:text-white/60 border-white/20 focus-visible:border-secondary focus-visible:ring-secondary/30" />
                                </FormControl>
                                <FormMessage />
                            </FormItem>} />

                    <FormField control={control} name="phone" render={({
          field
        }) => <FormItem>
                                <FormLabel className="text-white">Phone Number</FormLabel>
                                <FormControl>
                                    <Input type="tel" placeholder="(323) 492-6292" {...field} className="glass-effect text-white placeholder:text-white/60 border-white/20 focus-visible:border-secondary focus-visible:ring-secondary/30" />
                                </FormControl>
                                <FormDescription className="text-white/70 text-xs">Include area code</FormDescription>
                                <FormMessage />
                            </FormItem>} />
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                    <FormField control={control} name="pickup_date" render={({
          field
        }) => <FormItem>
                                <FormLabel className="text-white">Pick‑up Date</FormLabel>
                                <FormControl>
                                    <Input type="date" {...field} className="glass-effect text-white placeholder:text-white/60 border-white/20 focus-visible:border-secondary focus-visible:ring-secondary/30" />
                                </FormControl>
                                <FormDescription className="text-white/70 text-xs">Select the date of your reservation</FormDescription>
                                <FormMessage />
                            </FormItem>} />

                    <FormField control={control} name="pickup_time" render={({
          field
        }) => <FormItem>
                                <FormLabel className="text-white">Pick‑up Time</FormLabel>
                                <FormControl>
                                    <Input type="text" placeholder="HH:MM (24‑hour)" {...field} className="glass-effect text-white placeholder:text-white/60 border-white/20 focus-visible:border-secondary focus-visible:ring-secondary/30" />
                                </FormControl>
                                <FormDescription className="text-white/70 text-xs">Enter time in 24‑hour format (e.g., 14:30)</FormDescription>
                                <FormMessage />
                            </FormItem>} />
                </div>

                <FormField control={control} name="pickup_location" render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-white">Pick‑up Location</FormLabel>
                            <FormControl>
                                <Input placeholder="e.g., LAX Terminal 3" {...field} className="glass-effect text-white placeholder:text-white/60 border-white/20 focus-visible:border-secondary focus-visible:ring-secondary/30" />
                            </FormControl>
                            <FormDescription className="text-white/70 text-xs">Exact address or landmark</FormDescription>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="dropoff_location" render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-white">Drop‑off Location</FormLabel>
                            <FormControl>
                                <Input placeholder="e.g., Hotel Beverly Hills" {...field} className="glass-effect text-white placeholder:text-white/60 border-white/20 focus-visible:border-secondary focus-visible:ring-secondary/30" />
                            </FormControl>
                            <FormDescription className="text-white/70 text-xs">If different from pick‑up location</FormDescription>
                            <FormMessage />
                        </FormItem>} />

                <div className="grid md:grid-cols-2 gap-6">
                    <FormField control={control} name="vehicle_type" render={({
          field
        }) => <FormItem>
                                <FormLabel className="text-white">Vehicle Type</FormLabel>
                                <FormControl>
                                    <select {...field} className="glass-effect text-white border-white/20 focus-visible:border-secondary focus-visible:ring-secondary/30 flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50">
                                        <option value="" className="bg-primary-dark text-white">Select a vehicle</option>
                                        <option value="Sedan – Mercedes S‑Class" className="bg-primary-dark text-white">Sedan – Mercedes S‑Class</option>
                                        <option value="SUV – Cadillac Escalade" className="bg-primary-dark text-white">SUV – Cadillac Escalade</option>
                                        <option value="SUV – Range Rover" className="bg-primary-dark text-white">SUV – Range Rover</option>
                                    </select>
                                </FormControl>
                                <FormMessage />
                            </FormItem>} />

                    <FormField control={control} name="passengers" render={({
          field
        }) => <FormItem>
                                <FormLabel className="text-white">Number of Passengers</FormLabel>
                                <FormControl>
                                    <Input type="number" {...field} className="glass-effect text-white placeholder:text-white/60 border-white/20 focus-visible:border-secondary focus-visible:ring-secondary/30" />
                                </FormControl>
                                <FormDescription className="text-white/70 text-xs">Include driver in the count</FormDescription>
                                <FormMessage />
                            </FormItem>} />
                </div>

                <FormField control={control} name="special_requests" render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-white">Special Requests / Notes</FormLabel>
                            <FormControl>
                                <textarea placeholder="Any additional details (e.g., child seat, wheelchair access)" {...field} rows={4} className="glass-effect text-white placeholder:text-white/60 border-white/20 focus-visible:border-secondary focus-visible:ring-secondary/30 flex w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 resize-none" />
                            </FormControl>
                            <FormDescription className="text-white/70 text-xs">Optional</FormDescription>
                            <FormMessage />
                        </FormItem>} />

                {submitError && <div className="p-4 glass-effect border-2 border-red-500/50">
                        <p className="text-red-300">{submitError}</p>
                    </div>}

                <Button type="submit" disabled={isSubmitting} className="w-full bg-gradient-to-r from-secondary via-secondary-hover to-secondary-active text-white font-semibold text-base uppercase tracking-wider py-6 rounded-md shadow-strong hover:scale-[1.02] transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] disabled:opacity-50 disabled:cursor-not-allowed">
                    {isSubmitting ? <>
                            <Loader className="animate-spin mr-2 size-5" />
                            Submitting...
                        </> : 'Request Reservation'}
                </Button>
            </div>
        </Form>;
}
export default function ReservationForm() {
  return <section id="reservation-form" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden section-padding">
            {}
            <div className="absolute inset-0 bg-cover bg-center bg-[url(/img/luxury_suv_chauffeur_interior.png)]" style={{
      transform: 'translateZ(-1px) scale(1.5)',
      willChange: 'transform'
    }} />
            
            {}
            <div className="absolute inset-0 bg-primary-dark/60 backdrop-blur-[2px]" />

            {}
            <div className="relative z-10 w-full max-w-2xl mx-auto px-4">
                <Card className="glass-effect border-white/10 shadow-strong">
                    <CardHeader className="text-center space-y-3 border-b border-white/10 pb-6">
                        <CardTitle className="text-4xl md:text-5xl font-display text-white tracking-tight">
                            Reservation Form
                        </CardTitle>
                        <p className="text-white/80 text-base">
                            Complete the form below to request your luxury chauffeur service
                        </p>
                    </CardHeader>
                    
                    <CardContent className="pt-8">
                        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/executive_suv_black.png" alt="Chevy Suburban 2025" className="w-full h-auto rounded-lg mb-8 object-cover shadow-medium" />
                        <FormProvider className="w-full" formId="reservation_form_contact" sectionName="reservation-form" defaultValues={{
            full_name: "",
            email: "",
            phone: "",
            pickup_date: "",
            pickup_time: "",
            pickup_location: "",
            dropoff_location: "",
            vehicle_type: "",
            passengers: 1,
            special_requests: ""
          }} validationRules={{
            full_name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              required: true,
              pattern: "phone"
            },
            pickup_date: {
              required: true
            },
            pickup_time: {
              required: true
            },
            pickup_location: {
              required: true
            },
            vehicle_type: {
              required: true
            },
            passengers: {
              required: true
            }
          }} submitText="Request Reservation" successMessage="Thank you! Your reservation request has been received. We'll contact you shortly to confirm your booking." errorMessage="We couldn't process your reservation. Please try again or call us at 323-492-6292.">
                            <ReservationFormContent />
                        </FormProvider>
                    </CardContent>
                </Card>
            </div>
        </section>;
}